import React, { useEffect, useState } from 'react';
import {
	Paper,
	Container,
	CircularProgress,
} from '@mui/material';
import _ from 'lodash';
import EventTable from '../../components/EventTable';
import EventForm, { initialFormData } from '../../components/EventForm';

import classes from '../../api/classes';
import useTopBar from '../../hooks/useTopbar';
import { Toast } from '../../components/Toast/Toast';
import SidePopout from '../../components/SidePopout';
import { Button } from '../../components/Button/Button';
import { Add } from '@mui/icons-material';

const { Event } = classes;

function EventPage() {
	const [events, setEvents] = useState([]);
	const [addViewIsOpen, setAddViewIsOpen] = useState(false);
	const [toastData, setToastData] = useState({
		type: '',
		message: '',
	});
	const [editedEventData, setEditedEventData] = useState(initialFormData);

	const setUpdatedEvents = (updatedEvents) => setEvents([...updatedEvents].reverse());

	const onAddClick = () => {
		setEditedEventData(initialFormData);
		setAddViewIsOpen(true);
	};

	useEffect(() => {
		const fetchEvents = async () => {
			const fetchedEvents = await Event.fnCache.getEvents();
			setUpdatedEvents(fetchedEvents);
		};
		fetchEvents();
	}, []);

	// Close the toast after 10 seconds
	useEffect(() => {
		const timeout = setTimeout(() => {
			if (toastData.type !== 'loading') {
				setToastData({});
			}
		}, 10000);
		return () => clearTimeout(timeout);
	}, [toastData.message, toastData.type]);

	return (
		<div className="container mx-auto">
			<div className="flex justify-between items-center w-full mb-6">
				<span className="text-xl font-medium text-grey-800 tracking-normal">Events</span>
				<div className="flex relative justify-end gap-x-8 gap-y-2 flex-wrap grow">
					<Button
						icon={<Add />}
						onClick={onAddClick}
					>
						New Event
					</Button>
				</div>
			</div>
			<SidePopout open={addViewIsOpen}>
				<EventForm
					data={editedEventData}
					onSubmit={async (updatedEvents, actionType) => {
						setUpdatedEvents(updatedEvents);
						setAddViewIsOpen(false);
						setToastData({
							type: 'success',
							message: `Event ${actionType === 'add' ? 'added' : 'updated'}.`,
						});
					}}
					onFormDataChange={(data) => setEditedEventData(data)}
					availableTags={_.uniq(events.map((event) => event.tags).flat())}
					onClose={() => {
						setAddViewIsOpen(false);
					}}
				/>
			</SidePopout>
			<Paper variant="outlined">
				<EventTable
					events={events}
					onDelete={async (updatedEvents) => {
						setUpdatedEvents(updatedEvents);
						setToastData({
							type: 'info',
							message: 'Event deleted.',
						});
					}}
					onEdit={(id) => {
						setAddViewIsOpen(true);
						const eventToEdit = events.find((event) => event.id === id);
						// setFormTitle('Edit event');
						setEditedEventData(eventToEdit);
					}}
					onLoading={() => {
						setToastData({
							type: 'loading',
							message: 'Deleting event...',
						});
					}}
				/>
			</Paper>
			<Toast
				open={Boolean(toastData.message)}
				status={toastData.type === 'loading' ? 'info' : toastData.type}
				message={toastData.message}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				onClose={() => setToastData({})}
				icon={toastData.type === 'loading' ? <CircularProgress size="2rem" color="inherit" /> : undefined}
			/>
		</div>
	);
}

export default EventPage;
